import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

import i18n from '@speechki-frontend/core/i18n/i18n';

import authRoutes from '@speechki-frontend/core/auth/routes';
import editorRoutes from '@speechki-frontend/core/editor/routes';
import bookRoutes from '@speechki-frontend/core/book/routes';
import miscRoutes, { maintenanceRoutes, ErrorRoutes } from '@speechki-frontend/core/misc/routes';
import podcastsRoutes from '@speechki-frontend/core/podcasts/routes';

import dictionaryRoutes from './dictionary/routes';
import speakersRoutes from './speakers/routes';

const TITLE = i18n.global.t('routes.home');

let routes = [
    ...bookRoutes,
    ...authRoutes,
    ...editorRoutes,
    ...miscRoutes,
    ...podcastsRoutes,
    ...dictionaryRoutes,
    ...speakersRoutes,

    // always last
    ...ErrorRoutes,
];

if (process.env.VUE_APP_MAINTENANCE) {
    routes = maintenanceRoutes;
}

const { VUE_APP_ROUTER_BASEURL = '/', VUE_APP_IS_REVIEW = false } = process.env;
const history =
    VUE_APP_IS_REVIEW === 'true'
        ? createWebHashHistory(VUE_APP_ROUTER_BASEURL)
        : createWebHistory(VUE_APP_ROUTER_BASEURL);

const router = createRouter({
    history,
    routes,
    scrollBehavior(to) {
        // prevent scrolling to top for editor page
        if (to.name !== 'editor') {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (process.env.VUE_APP_MAINTENANCE) return next();

    const token = localStorage.getItem('token');
    if (to.meta.guest) {
        if (token && to.path === '/login') {
            return router
                .push({
                    name: 'home',
                })
                .catch(() => {});
        } else {
            next();
        }
    } else {
        if (!token) {
            return router
                .push({
                    name: 'login',
                    query: to.query,
                })
                .catch(() => {});
        } else {
            next();
        }
    }
});

router.afterEach((to) => {
    if (to.fullPath !== '/login') {
        localStorage.setItem('lastroute', to.fullPath);
    }

    if (to.name === 'editor' || to.name === 'embed') return;

    document.title = to.meta && to.meta.title ? to.meta.title + ' — ' + TITLE : TITLE;
});

export default router;
